export enum UserStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

export enum UserTypeEnum {
  ANONYMOUS_USER = 'ANONYMOUS_USER',
  USER = 'USER',
  ADMIN = 'ADMIN',
  MASTER_ADMIN = 'MASTER_ADMIN',
}

export enum UserRoleTypeEnum {
  ACCOUNTANT = 'accountant',
  FRANCHISEE_ADMIN = 'franchisee_admin',
  STORE_ADMIN = 'store_admin',
  MASTER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  STORE_KEEPER = 'cashier',
}

export const UserRolePriority = {
  [UserRoleTypeEnum.STORE_KEEPER]: 1,
  [UserRoleTypeEnum.STORE_ADMIN]: 12,
  [UserRoleTypeEnum.FRANCHISEE_ADMIN]: 14,
  [UserRoleTypeEnum.ADMIN]: 20,
  [UserRoleTypeEnum.MASTER_ADMIN]: 25,
};
